<div class="dialog-container">
  <button *ngIf="!data.returnFunctionality" class="close-btn" (click)="close()">
    <img src="assets/close.svg" alt="" />
  </button>

  <img
    class="cust-mar"
    *ngIf="data.mode === 'success'"
    src="assets/modal-success-img.svg"
    alt=""
  />
  <img
    class="cust-mar"
    *ngIf="data.mode === 'warning'"
    src="assets/modal-warning-img.svg"
    alt=""
  />

  <h1 class="title cust-mar">{{ data.title }}</h1>
  <p class="desc mt-4">{{ data.description }}</p>

  <div *ngIf="data.functionality" class="row w-100 cust-mar">
    <div class="col-6">
      <!-- подтверждаем удаление -->
      <button class="secondary-btn" (click)="apply()">Удалить</button>
    </div>
    <div class="col-6">
      <!-- закрываем без действия -->
      <button class="primary-btn" (click)="close()">Отменить</button>
    </div>
  </div>
  <div *ngIf="data.returnFunctionality" class="row w-100 cust-mar">
    <div class="col-12">
      <a class="primary-btn return-btn" href="/">Вернуться на главную</a>
    </div>
  </div>
</div>
